import { Type } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { CwtStore } from "@cawita/core-front/state";
import { CwtStoreCheckGuard } from "./store-check.guard";

export function CwtStoreInitializedGuard(store: Type<CwtStore<unknown>>): CanActivateFn {
    return CwtStoreCheckGuard(store, () => true);
}